import Vue from 'vue'
import Router from 'vue-router'
import User from '@/components/User'
import Talk from '@/components/Talk'
import Map from '@/components/Map'
import Bell from '@/components/Bell'
import Setting from '@/components/pc/setting/Setting'
import Manual from '@/components/Manual'
import License from '@/components/LicenseForEndUser'
import Account from '@/components/Account'
import Billing from "@/components/BillingForEndUser"
import Restrictions from '@/components/RestrictionsManagement'
import AuditLog from '@/components/AuditLogForUser'
import KeyVault from '@/components/KeyVault'
import TwoPhaseLoginInfo from '@/components/pc/setting/twophasemethod/TwoPhaseLoginInfo'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'User',
            component: User
        },
        {
            path: '/talk',
            name: 'Talk',
            component: Talk
        },
        {
            path: '/setting',
            name: 'Setting',
            component: Setting
        },
        {
            path: '/manual',
            name: 'Manual',
            component: Manual
        },
        {
            path: '/restrictions',
            name: 'Restrictions',
            component: Restrictions
        },
        {
            path: '/map',
            name: 'Map',
            component: Map
        },
        {
            path: '/bell',
            name: 'Bell',
            component: Bell
        },
        {
            path: '/license',
            name: 'License',
            component: License
        },
        {
            path: '/account',
            name: 'Account',
            component: Account
        },
        {
            path: '/billing',
            name: 'BillingForUser',
            component: Billing
        },
        {
            path: '/auditlog',
            name: 'AuditLogForUser',
            component: AuditLog
        },
        {
            path: '/keyvault',
            name: 'KeyVault',
            component: KeyVault
        },
        {
            path: '/twophaselogininfo',
            name: 'TwoPhaseLoginInfo',
            component: TwoPhaseLoginInfo
        }
    ]
})
